import {
  Alert,
  Box,
  Grid2 as Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./Footer.module.scss";
import Image from "next/image";
import FooterRightArrow from "@/public/assets/ic_right_arrow_footer.svg";
import RightArrow from "@/public/assets/ic_right_arrow.svg";
import Link from "next/link";
import { useDispatch, useSelector } from "react-redux";
import { blogHeaderRedux } from "@/app/store/blog-header/reducers";
import Snackbar from "@mui/material/Snackbar";
import { useRouter } from "next/router";
import Constants from "@/utils/constants";
import { envConfig } from "@/envConfig";

const Footer = () => {
  const isSmallScreen = useMediaQuery("(max-width: 899px)");
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [openSnackBar, setOpenSnackBar] = useState(false);

  // const handleClose = () => {
  //   setSnackbarState(false);
  // };

  const dispatch = useDispatch();
  const createSubscribe = (data) =>
    dispatch(blogHeaderRedux.actions.createSubscribeRequest(data));
  const createSubscribeReset = () =>
    dispatch(blogHeaderRedux.actions.createSubscribeReset());

  const subscribeState = useSelector(
    (state) => state?.blogHeader?.createSubscribeDetails
  );

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubscribe = (e) => {
    e.preventDefault();

    if (!email) {
      setError("Email is required.");
    } else if (!validateEmail(email)) {
      setError("Please enter a valid email id.");
    } else {
      setError("");
      createSubscribe({ email });
    }
  };

  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  useEffect(() => {
    if (subscribeState?.isError || subscribeState?.isSuccess) {
      setSnackbarMessage(
        subscribeState.isError
          ? subscribeState.error || "Something Went Wrong"
          : "You have successfully subscribed!"
      );
      setSnackbarSeverity(subscribeState.isError ? "error" : "success");
      setOpenSnackBar(true);
    }

    if (subscribeState?.isSuccess) {
      setEmail("");
    }
  }, [subscribeState?.isError, subscribeState?.isSuccess]);

  useEffect(() => {
    if (subscribeState?.isError || subscribeState?.isSuccess) {
      setOpenSnackBar(true);
    }

    if (subscribeState?.isSuccess) {
      setEmail("");
    }
  }, [subscribeState?.isError, subscribeState?.isSuccess]);

  const router = useRouter();

  useEffect(() => {
    setEmail("");
    setError("");
  }, [router.pathname, router?.query?.slug]);

  const handleCloseSnackBar = () => {
    setOpenSnackBar(false);
    createSubscribeReset();
  };

  return (
    <>
      <Snackbar
        open={openSnackBar}
        autoHideDuration={5000}
        onClose={handleCloseSnackBar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackBar}
          severity={snackbarSeverity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Box className={styles.footerWrapper}>
        <Box className={styles.footerContent} pt={isSmallScreen ? 2 : 4}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
              <Typography
                variant="h6"
                component={"h6"}
                my={isSmallScreen ? 1 : 3}
                mb={isSmallScreen ? 4 : 0}
              >
                Stay tuned
              </Typography>
            </Grid>
            <Grid
              size={{ sm: 12, md: 12, lg: 6 }}
              sx={{
                width: "100%",
              }}
            >
              <div className={styles.inputHolder}>
                <input
                  type="email"
                  placeholder="Your e-mail"
                  value={email}
                  maxLength={Constants.InputCharacterLimit}
                  onChange={(e) => {
                    if (
                      e.target.value?.length <= Constants.InputCharacterLimit
                    ) {
                      setEmail(e.target.value);
                      setError("");
                    }
                  }}
                />
                <div className={styles.divider}></div>
                {isSmallScreen && error && (
                  <p
                    style={{
                      color: "red",
                      fontFamily: "Inter",
                      fontSize: "16px",
                    }}
                  >
                    {error}
                  </p>
                )}
                <button onClick={handleSubscribe}>SUBSCRIBE</button>
              </div>
              {!isSmallScreen && error && (
                <p
                  style={{
                    color: "red",
                    marginTop: "-10px",
                    marginBottom: "10px",
                    fontFamily: "Inter",
                    fontSize: "16px",
                  }}
                >
                  {error}
                </p>
              )}

              <div>
                <p className={styles.subscribeCaption}>
                  By clicking Subscribe button you agree to our{" "}
                </p>

                <p className={styles.tncText}>
                  <Link
                    className={styles.tncText}
                    href={
                      envConfig.ENV_TYPE === "development"
                        ? "https://website-stage.simpleenergy.in/privacy-policy"
                        : "https://www.simpleenergy.in/privacy-policy"
                    }
                    target="_blank"
                  >
                    Privacy Policy
                  </Link>{" "}
                  &{" "}
                  <Link
                    className={styles.tncText}
                    href={
                      envConfig.ENV_TYPE === "development"
                        ? "https://website-stage.simpleenergy.in/terms-and-condition"
                        : "https://www.simpleenergy.in/terms-and-condition"
                    }
                    target="_blank"
                  >
                    Terms
                  </Link>
                </p>
              </div>
            </Grid>
          </Grid>

          <Stack
            direction={isSmallScreen ? "column" : "row"}
            className={styles.attentionSectionWrapper}
          >
            <Stack direction={"row"} className={styles.attentionTextContent}>
              <p className={styles.attentionText}>Attention</p>

              {/* {isSmallScreen && (
              <Box sx={{ width: "40px", height: "30px", position: "relative" }}>
                <Image
                  src={FooterRightArrow.src}
                  alt={"Right Arrow"}
                  layout="fill"
                  objectFit="contain"
                />
              </Box>
            )} */}
            </Stack>

            <Stack
              direction={"row"}
              spacing={2}
              className={styles.warningTextContent}
            >
              <p className={styles.warningText}>
                Beware of scammers. SimpleEnergy will never ask for your
                personal details
              </p>

              {/* {!isSmallScreen && (
              <Box sx={{ width: "40px", height: "30px", position: "relative" }}>
                <Image
                  src={RightArrow.src}
                  alt={"Right Arrow"}
                  layout="fill"
                  objectFit="contain"
                />
              </Box>
            )} */}
            </Stack>
          </Stack>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
